import { render } from "./ProductDetailModal.vue?vue&type=template&id=dd40a928&scoped=true"
import script from "./ProductDetailModal.vue?vue&type=script&lang=js"
export * from "./ProductDetailModal.vue?vue&type=script&lang=js"

import "./ProductDetailModal.vue?vue&type=style&index=0&id=dd40a928&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd40a928"]])

export default __exports__